import * as t from 'io-ts'
import { nullable } from 'lib/request'

export const TVersion = nullable(
  t.strict({
    latestRelease: t.string,
  }),
)
